import SubPagePreLoader from '@/_containers/sub-page-loader';

export function Loading() {
  return <SubPagePreLoader />;
}
